/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {BsModalService} from 'ngx-bootstrap/modal';
import {Observable} from 'rxjs';

import {SignInModalComponent} from './sign-in-modal.component';

@Injectable({providedIn: 'root'})
export class SignInModalService {
  constructor(private readonly bsModalService: BsModalService) {
  }

  open(rejectionData?: any): Observable<any> {
    const modalRef = this.bsModalService.show(SignInModalComponent, {
      backdrop: 'static',
      keyboard: false,
      ignoreBackdropClick: true,
      initialState: {
        rejection: rejectionData
      }
    });
    return (modalRef.content as SignInModalComponent).sessionResult.asObservable();
  }
}
